import { scan, validateTaxId, validateCarrierNo } from '@/api/member';
import {
  checkout,
  testCheckout,
  addOrUpdateOrderDiscount,
  cancelCheckout,
  registerCheckoutEvent,
  redeemWelcomeGift,
} from '@/api/order';
export default {
  namespaced: true,
  state: {
    transaction: {},
    invoiceInfo: {},
    payment: [],
    checkoutValid: false,
    permission: {},
  },

  getters: {
    getInvoice: (state) => state.invoiceInfo,
    getCarrier: (state) => state.invoiceInfo?.carrier,
    getTax: (state) => state.invoiceInfo?.buyer_tax_id,
    getInvoiceMode: (state) => state.invoiceInfo?.invoice_mode,
    getOrderAmount: (state) => state.transaction?.total,
    getPaidList: (state) => state.payment,
    getCheckoutValid: (state) => state.checkoutValid,
    chooseEntertain: (state) => state.transaction?.entertain_list,
    getTransaction: (state) => state.transaction,
    getPayStatus: (state) => state.transaction?.already_pay || state.transaction?.total < 0,
    getPaymentPermission: (state) => state.permission.payment_method,
    getOrderEditable: (state) => state.permission.editable,
  },

  mutations: {
    SET_TRANSACTION(state, data) {
      state.transaction = data;
    },
    SET_INVOICE_INFO(state, data) {
      state.invoiceInfo = data;
    },
    SET_TAX(state, data) {
      state.invoiceInfo.buyer_tax_id = data;
    },
    SET_INVOICE_MODE(state, data) {
      state.invoiceInfo.invoice_mode = data;
      state.invoiceInfo.carrier = [];
      // state.invoiceInfo.buyer_tax_id = '';
    },
    SET_CARRIER(state, data) {
      switch (data.invoice_carrier_type) {
        case 'card_carrier':
          state.invoiceInfo.carrier = [];
          state.invoiceInfo.buyer_tax_id = '';
          state.invoiceInfo.carrier.push(data);
          break;
        case 'mobile_carrier':
          state.invoiceInfo.carrier.forEach((e, index) => {
            if (e.invoice_carrier_type !== 'love_code') state.invoiceInfo.carrier.splice(index, 1);
          });
          state.invoiceInfo.carrier.push(data);
          break;
        case 'citizen_digital_certificate':
          state.invoiceInfo.carrier = [];
          state.invoiceInfo.carrier.push(data);
          break;
        case 'love_code':
          state.invoiceInfo.carrier.forEach((e, index) => {
            if (e.invoice_carrier_type !== 'mobile_carrier') state.invoiceInfo.carrier.splice(index, 1);
          });
          state.invoiceInfo.carrier.push(data);
          state.invoiceInfo.buyer_tax_id = '';
          break;
      }
    },
    DELETE_DEVICE(state) {
      state.invoiceInfo.carrier.forEach((e, index) => {
        if (e.invoice_carrier_type === 'love_code') state.invoiceInfo.carrier.splice(index, 1);
        else if (e.invoice_carrier_type === 'card_carrier') state.invoiceInfo.carrier.splice(index, 1);
      });
    },
    CLEAR_CARRIER(state, type) {
      if (type === 4) {
        state.invoiceInfo.carrier.forEach((e, index) => {
          if (e.invoice_carrier_type === 'mobile_carrier') state.invoiceInfo.carrier.splice(index, 1);
        });
      } else if (type === 5) {
        state.invoiceInfo.carrier.forEach((e, index) => {
          if (e.invoice_carrier_type === 'citizen_digital_certificate' || e.invoice_carrier_type === 'love_code')
            state.invoiceInfo.carrier.splice(index, 1);
        });
      }
    },
    SET_CHECKOUT_VALID(state, data) {
      state.checkoutValid = data;
    },
    SET_PAYMENT(state, data) {
      state.payment = data;
    },
    SET_PAID_LIST(state, item) {
      const index = state.payment.findIndex((el) => el.type === item.type);
      if (index === -1) {
        state.payment.push(item);
      } else {
        state.payment.splice(index, 1, item);
      }
    },
    REMOVE_PAID(state, index) {
      state.payment.splice(index, 1);
    },
    CLEAR_PAID_LIST(state) {
      if (state.payment[0].type === 3 || state.payment[0].type === 4) state.invoiceInfo.carrier = [];
      state.payment = [];
    },
    SET_PERMISSION(state, data) {
      state.permission = data;
    },
    RESET(state) {
      state.transaction = {};
      state.invoiceInfo = {};
      state.payment = [];
      state.permission = {};
    },
  },

  actions: {
    //檢查統編
    async doCheckTax({ commit }, data) {
      const res = await validateTaxId(data);
      if (res.is_validate) commit('SET_TAX', res.invoice_no);
      return Promise.resolve();
    },
    //掃描載具
    async doQueryDevice({ commit, rootGetters }, type) {
      commit('CLEAR_CARRIER', type);
      const order_id = rootGetters['order/getOrderId'];
      const res = await scan({ scan_method: type, test_mode: 0, order_id });
      // console.log(res);
      commit('SET_CARRIER', res.carrier);
      // if (type === 4) {
      //   commit('SET_CARRIER', {
      //     invoice_carrier_type: 'mobile_carrier',
      //     code: '/AB123456',
      //     validate_status: 1,
      //     validate_status_description: '驗證成功',
      //   });
      // } else {
      //   commit('SET_CARRIER', {
      //     invoice_carrier_type: 'citizen_digital_certificate',
      //     code: '333',
      //     validate_status: 1,
      //     validate_status_description: '驗證成功',
      //   });
      // }
      return Promise.resolve();
    },
    //檢查手動輸入條碼
    async doCheckCarrierNo({ commit, rootGetters }, data) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await validateCarrierNo({ ...data, order_id });
      // console.log(res);
      commit('SET_CARRIER', res.carrier);
      return Promise.resolve();
    },
    //整單折扣
    async doOrderDiscount({ commit, rootGetters }, discounts) {
      const data = {
        order_id: rootGetters['order/getOrderId'],
        discounts,
      };
      const res = await addOrUpdateOrderDiscount(data);
      commit('SET_TRANSACTION', res.transaction);
      commit('cart/SET_CART_DATA', res.cart, { root: true });
      return Promise.resolve();
    },

    //結帳
    async doCheckout({ getters, rootGetters, dispatch }, data) {
      const payload = {
        order_id: rootGetters['order/getOrderId'],
        buyer_tax_id: getters.getTax,
        invoice_mode: getters.getInvoiceMode,
        item_list: rootGetters['cart/getCart'],
        payment: getters.getPaidList,
        member_card: rootGetters['member/getMemberInformation'],
        carrier: getters.getCarrier,
        ...data,
      };
      let res;
      //測試模式結帳時 api 需切換成 testCheckout
      if (rootGetters['system/getIsTestMode']) {
        res = await testCheckout(payload);
      } else {
        res = await checkout(payload);
      }
      dispatch('system/getEcho', '', { root: true });
      return Promise.resolve(res);
    },
    //取消結帳
    async doCancelCheckout({ rootGetters }, order_id) {
      await cancelCheckout(order_id || rootGetters['order/getOrderId']);
      return Promise.resolve();
    },
    //結帳活動
    async doRegisterCheckoutEvent({ rootGetters }, data) {
      await registerCheckoutEvent({ order_id: rootGetters['order/getOrderId'], ...data });
      return Promise.resolve();
    },
    //結帳活動 - 來店禮
    async doRedeemWelcomeGift({ rootGetters }, data) {
      await redeemWelcomeGift({ order_id: rootGetters['order/getOrderId'], ...data });
      return Promise.resolve();
    },
  },
};
